export default __webpack_public_path__ + "static/media/Compass group.1ca1ba59.png";